import { render, staticRenderFns } from "./appendix.vue?vue&type=template&id=f54e140e&scoped=true&"
import script from "./appendix.vue?vue&type=script&lang=js&"
export * from "./appendix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54e140e",
  null
  
)

export default component.exports